// ── BrandChevron — der markeneigene Menü-Pfeil der Red.-App ───────────────
// Kein generischer Lucide-Winkel mehr. Eigene, durchgängige Geometrie im
// iOS-Stil: schlank (Apex-Winkel ~76°, deutlich spitzer/aufrechter als der
// 90°-Standard), runde Kappen, ruhige Strichstärke. Überall identisch — vom
// Settings-Disclosure bis zum Sidebar-Collapse.
//
// Signatur „eigenständiges Produkt": optionaler `dot` setzt einen kleinen
// roten Punkt in Laufrichtung VOR die Spitze — das Echo des `.` aus der
// red.-Wordmark. Standardmäßig aus (dichte Menüzeilen bleiben clean); für
// Hero-/Marketing-Stellen (Upgrade ›, Auswahlkacheln) anschaltbar.
//
// Akzent ausschließlich über Stroke/Schrift — keine getönte Fläche, keine
// Pille, kein Glow (siehe Memory feedback_no_pills_borders_glow).

import React from 'react';

const RED = '#E4544A';

// Schlanke iOS-Geometrie, zentriert im 24er-Viewbox.
// dx 5.6 / dy 7.2  →  Halbwinkel atan(5.6/7.2) ≈ 38°  →  Apex ≈ 76°.
const PATHS = {
  right: 'M10 4.8 L15.6 12 L10 19.2',
  left:  'M14 4.8 L8.4 12 L14 19.2',
  down:  'M4.8 10 L12 15.6 L19.2 10',
  up:    'M4.8 14 L12 8.4 L19.2 14',
};

// Punkt-Position knapp hinter der Spitze, in Laufrichtung.
const DOTS = {
  right: { cx: 19,  cy: 12 },
  left:  { cx: 5,   cy: 12 },
  down:  { cx: 12,  cy: 19 },
  up:    { cx: 12,  cy: 5  },
};

/**
 * @param {'right'|'left'|'up'|'down'} dir   Laufrichtung (Default 'right')
 * @param {number} size                      Kantenlänge px (Default 16)
 * @param {string} color                     Stroke-Farbe (Default 'currentColor')
 * @param {number} sw                         Strichstärke (Default 1.7)
 * @param {boolean} dot                       Marken-Punkt vor der Spitze
 * @param {string} dotColor                   Punktfarbe (Default Rot)
 */
export default function BrandChevron({
  dir = 'right',
  size = 16,
  color = 'currentColor',
  sw = 2.4,
  dot = false,
  dotColor = RED,
  style,
  ...rest
}) {
  const d = PATHS[dir] || PATHS.right;
  const dotPos = DOTS[dir] || DOTS.right;
  // Punkt skaliert mit der Strichstärke, bleibt aber dezent.
  const r = Math.max(1, sw * 0.7);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ display: 'block', flexShrink: 0, ...style }}
      {...rest}
    >
      <path d={d} />
      {dot && <circle cx={dotPos.cx} cy={dotPos.cy} r={r} fill={dotColor} stroke="none" />}
    </svg>
  );
}

// Roh-Pfade für Stellen, die nur ein `d` brauchen (z.B. Icons-Map).
export const BRAND_CHEVRON_PATHS = PATHS;
